import { inputTypes } from 'components/common/FormElements/Input'
import { createCheckboxViewModel } from './helpers'
import { PROMOTION_REBATE_FIELD_NAME, PROMOTION_TIRE_FIELD_NAME } from './constants'

const createViewModel = ({ activePromotions = [], availablePromotions = []}) => ({
  activePromotion: {
    name: PROMOTION_REBATE_FIELD_NAME,
    defaultData: createCheckboxViewModel({ activePromotions })
  },
  availablePromotions: {
    name: PROMOTION_TIRE_FIELD_NAME,
    type: 'radio',
    inputType: inputTypes.RADIO_INPUT
  }
})

export default createViewModel

